import {
  Avatar,
  Box,
  Grid,
  Link,
  Paper,
  Stack,
  styled,
  Typography,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import Controls from "../controls/Controls";
import PlayArrowIcon from "@mui/icons-material/PlayArrow";
import SignalCellular4BarIcon from "@mui/icons-material/SignalCellular4Bar";
import {
  addNewMessage,
  sendMessage,
  loadIssuesMessages,
  getIssuesMessages,
} from "../../store/issues";
import { useDispatch, useSelector } from "react-redux";
import { format } from "date-fns";
import SendIcon from '@mui/icons-material/Send';

function stringToColor(string) {
  let hash = 0;
  let i;
  /* eslint-disable no-bitwise */
  for (i = 0; i < string.length; i += 1) {
    hash = string.charCodeAt(i) + ((hash << 5) - hash);
  }

  let color = "#";

  for (i = 0; i < 3; i += 1) {
    const value = (hash >> (i * 8)) & 0xff;
    color += `00${value.toString(16)}`.slice(-2);
  }
  /* eslint-enable no-bitwise */

  return color;
}

function stringAvatar(name) {
  return {
    sx: {
      bgcolor: stringToColor(name),
    },
    children: `${name?.split(" ")[0][0]}${name?.split(" ").length > 1
        ? name?.split(" ")[1][0]
        : name?.split(" ")[0][1]
      }`,
  };
}

const messageList = [
  {
    id: 1,
    message: "left massage",
    dateTime: "11 am, 9 jun",
    userId: 1,
    messageType: "receive",
    userName: "Kent Dodds",
  },
  {
    id: 2,
    message: "right massage",
    dateTime: "11 am, 9 jun",
    userId: 2,
    messageType: "send",
    userName: "Jed Watson",
  },
];

const LeftMessageBox = styled(Box)(({ theme }) => ({
  color: "darkslategray",
  backgroundColor: "#e9f4ff",
  paddingLeft: theme.spacing(2),
  paddingRight: theme.spacing(2),
  paddingTop: theme.spacing(1),
  paddingBottom: theme.spacing(1),
  borderRadius: 4,
  maxWidth: "60%",
  marginLeft: "-12px",
  marginTop: "30px",
}));

const RightMessageBox = styled(Box)(({ theme }) => ({
  color: "darkslategray",
  backgroundColor: "#d2fad3",
  paddingLeft: theme.spacing(2),
  paddingRight: theme.spacing(2),
  paddingTop: theme.spacing(1),
  paddingBottom: theme.spacing(1),
  borderRadius: 4,
  maxWidth: "60%",
  marginRight: "-12px",
  marginTop: "30px",
}));

export default function DiscussionPanel(props) {
  const { setNotify, setOpenPopup,
     selectedIssue,allAppDocuments,handleDownloadFile } = props;
  const [newMessage, setNewMessage] = useState("");
  //const [messages, setMessages] = useState(messageList);
  const dispatch = useDispatch();

  const messages = useSelector(getIssuesMessages);
  console.log(messages);
  //console.log(selectedIssue);
  useEffect(() => {
    dispatch(loadIssuesMessages(selectedIssue.id));
    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const leftMessage = (msg, name, date,upId) => {
    //console.log(name);
    return (
      <Box sx={{ display: "flex" }}>
        <Avatar {...stringAvatar(name.trim())} />
        <SignalCellular4BarIcon
          sx={{
            transform: "rotate(45deg)",
            marginTop: "18px",
            marginLeft: "10px",
            color: "#e9f4ff",
          }}
        />
        <LeftMessageBox>
          <Typography variant="subtitle2">{name}</Typography>
          <Typography variant="body2" sx={{ mt: 1, mb: 0 }}>
            <div dangerouslySetInnerHTML={{ __html: msg }}></div>
          </Typography>
          <Typography variant="body2" sx={{ mt: -2, mb: 2 }}>
            {allAppDocuments && allAppDocuments?.filter(x => x.ciid === selectedIssue.ciid && x.documentType === "Messaging" && x.uploadId === upId).map((doc) => (
              <>
                <Link
                  underline="none"
                  sx={{ cursor: "pointer" }}
                  onClick={() => handleDownloadFile(doc)}
                >
                  {doc.docName}
                </Link>
                <br />
              </>
            ))}
          </Typography>
          <Typography
            align="right"
            variant="body2"
            sx={{ fontWeight: "bold", fontSize: "11px" }}
          >
            {format(new Date(date), "MM/dd/yyyy, h:mma")}
          </Typography>
        </LeftMessageBox>
      </Box>
    );
  };

  const rightMessage = (msg, name, date) => {
    return (
      <Box sx={{ display: "flex", flexDirection: "row-reverse", mt: 2 }}>
        <Avatar {...stringAvatar(name)} />
        <SignalCellular4BarIcon
          sx={{
            transform: "rotate(45deg)",
            marginTop: "18px",
            marginRight: "10px",
            color: "#d2fad3",
          }}
        />
        <RightMessageBox>
          <Typography variant="subtitle2">{name}</Typography>
          <Typography variant="body2" sx={{ mt: 1, mb: 1 }}>
            <div dangerouslySetInnerHTML={{ __html: msg }}></div>
          </Typography>
          <Typography
            align="right"
            variant="body2"
            sx={{ fontWeight: "bold", fontSize: "11px" }}
          >
            {format(new Date(date), "MM/dd/yyyy, h:mma")}
          </Typography>
        </RightMessageBox>
      </Box>
    );
  };

  const handleSendMessage = () => {
    // const msgId = messages[messageList.length - 1].id + 1;
    // const msgObj = {
    //   id: msgId,
    //   dateTime: new Date(),
    //   message: newMessage,
    //   senderId: 2,
    //   receiverId: 3,
    //   messageType: "send",
    //   userName: "WorkFinity Support Team",
    // };

    const obj = {
      issueId: selectedIssue.id,
      messages: newMessage,
    };

    //const updateMessage = [...messages, msgObj];
    //setMessages(updateMessage);
    dispatch(sendMessage(obj));
    setNewMessage("");
  };

  const handleNewMessageChange = (e) => {
    setNewMessage(e.target.value);
  };
  return (
    <Box>
      <Paper
        variant="outlined"
        sx={{ height: 350, mb: 2, p: 3, overflow: "auto" }}
      >
        {messages.map((item) => {
          if (item.messageType === 1) {
            return rightMessage(
              item.messageData,
              item.fromName,
              item.addedDatetime
            );
          }
          if (item.messageType === 2)
            return leftMessage(
              item.messageData,
              item.fromName,
              item.addedDatetime,
              item.uploadId
            );
        })}
        {/* {leftMessage(
          "Lorem Ipsum is simply dummy text of the printing and typesetting industry.",
          "Kent Dodds"
        )}
        {rightMessage(
          "Lorem Ipsum is simply dummy text of the printing and typesetting industry.",
          "Tim Neutkens"
        )} */}
      </Paper>
      <Stack direction="row" spacing={2}>
        <Controls.Input
          name="chatMsg"
          label="Type your message"
          value={newMessage}
          onChange={handleNewMessageChange}
        ></Controls.Input>
        <Controls.Button
          name="send"
          text="Send"
          startIcon={<SendIcon />}
          variant="outlined"
          onClick={handleSendMessage}
          sx={{
                  color: 'black',
                  border: "1px solid black",
                  '&:hover': {
                    backgroundColor: 'black',
                    color: 'white',

                  }
                }}
        ></Controls.Button>
      </Stack>
    </Box>
  );
}
